import ErrorBoundary from '~/components/_common/ErrorBoundary';
import Register from '~/components/Register';

const App = () => (
    <ErrorBoundary>
        <Register />
    </ErrorBoundary>
);

export default App;